import { render } from "./AdminLink.vue?vue&type=template&id=e68f2314"
import script from "./AdminLink.vue?vue&type=script&lang=js"
export * from "./AdminLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__